__turbopack_context__.v({
  "grid": "cIqdoa_grid",
  "maxWidthFull": "cIqdoa_maxWidthFull",
  "maxWidthLg": "cIqdoa_maxWidthLg",
  "maxWidthMd": "cIqdoa_maxWidthMd",
  "maxWidthSm": "cIqdoa_maxWidthSm",
  "maxWidthXl": "cIqdoa_maxWidthXl",
  "pageLayout": "cIqdoa_pageLayout",
  "spacingComfortable": "cIqdoa_spacingComfortable",
  "spacingCompact": "cIqdoa_spacingCompact",
  "spacingDefault": "cIqdoa_spacingDefault",
  "spacingSpacious": "cIqdoa_spacingSpacious",
  "withMargins": "cIqdoa_withMargins",
});
